// extracted by mini-css-extract-plugin
export default {"brandcenter":"Navbar_brandcenter__fy6CC","logo":"Navbar_logo__3H5Zh","header":"Navbar_header__-Bvo6"};